import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9838dd88&scoped=true&lang=html&"
import script from "./discountService.js?vue&type=script&lang=js&"
export * from "./discountService.js?vue&type=script&lang=js&"
import style0 from "./discountService.styl?vue&type=style&index=0&id=9838dd88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9838dd88",
  null
  
)

export default component.exports